import React from 'react'
import "./financialChains.scss"

//Imagens:
import ImgWhereYouNeed from "../../../../assets/financialsOperational/Ativo_3-8.png"
import { useTranslation } from 'react-i18next'

function FinancialChains() {
  const {t} =  useTranslation()

  return (
    <div className='container-b2c-profits'>
        <div className="img-b3c-profits">
            <img src={ImgWhereYouNeed} alt="" />
        </div>
        <div className='financialsOperational-text'>
            <h1>{t("corp_chain.title")}</h1>
            <p>{t("corp_chain.analyze_corp_chain.section_text_1")}</p>
            <p>{t("corp_chain.analyze_corp_chain.section_text_2")}</p>
            <p>{t("corp_chain.analyze_corp_chain.section_text_3")}</p>
            <a href="/form">
              <button id='btn-b3c-profits'>{t("buttons.demo_btn_alternative_text_1")}</button>
            </a>
        </div>
    </div>
  )
}

export default FinancialChains